import { render, staticRenderFns } from "./gBreadcrumb.vue?vue&type=template&id=70a15a2f&"
import script from "./gBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./gBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "gBreadcrumb.vue"
export default component.exports